import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DepartmentSelectionResult } from '@core/models';
import { Observable } from 'rxjs';
import {
  DialogConfirmActionComponent,
  DialogConfirmActionData,
} from '../../dialogs/dialog-confirm-action/dialog-confirm-action.component';
import { DialogConfirmCloseComponent } from '../../dialogs/dialog-confirm-close/dialog-confirm-close.component';
import { DialogSelectDepartmentComponent } from '../../dialogs/dialog-select-department/dialog-select-department.component';

@Injectable()
export class CommonDialogsService {
  private dialogRef!: MatDialogRef<any>;

  constructor(private readonly dialog: MatDialog) {}

  closeConfirm() {
    this.dialogRef = this.dialog.open<DialogConfirmCloseComponent, any, any>(DialogConfirmCloseComponent, {
      maxWidth: '560px',
    });
    return this.dialogRef.afterClosed();
  }

  setDepartmentsDialog(data: DepartmentSelectionResult | null): Observable<DepartmentSelectionResult | undefined> {
    this.dialogRef = this.dialog.open<
      DialogSelectDepartmentComponent,
      DepartmentSelectionResult,
      DepartmentSelectionResult
    >(DialogSelectDepartmentComponent, {
      maxWidth: '560px',
      disableClose: true,
      data: { all_departments_access: data?.all_departments_access || false, departments: data?.departments || [] },
    });

    return this.dialogRef.afterClosed();
  }

  confirmAction(data: DialogConfirmActionData): Observable<boolean | undefined> {
    this.dialogRef = this.dialog.open<DialogConfirmActionComponent, DialogConfirmActionData, boolean>(
      DialogConfirmActionComponent,
      { maxWidth: '480px', data },
    );
    return this.dialogRef.afterClosed();
  }

  closeDialog() {
    this.dialogRef?.close();
  }
}
